"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StateReview = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject, _templateObject2;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 175px;\n  border: 1px solid #f0f0f0;\n  position: relative;\n  height: fit-content;\n\n  .chk-container {\n    position: absolute;\n    top: 5px;\n    left: 5px;\n    z-index: 5;\n    height: 16px;\n  }\n\n  .data-body {\n    padding: 10px;\n    border-bottom: 1px solid #f0f0f0;\n\n    & > h3,\n    & > p {\n      color: #262626;\n      font-family: ", ";\n      font-size: 12px;\n      line-height: 16px;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n\n      & + p {\n        margin-top: 5px;\n      }\n    }\n    p {\n      font-size: 10px;\n      line-height: 12px;\n      color: #808080;\n    }\n  }\n\n  .status-slider {\n    display: flex;\n    padding: 5px 10px;\n    overflow: auto;\n    border-bottom: 1px solid #f0f0f0;\n    flex-wrap: nowrap;\n\n    .status-element {\n      display: flex;\n\n      .srv-name {\n        background-color: #808080;\n        padding: 0 10px;\n        border-radius: 5px;\n        p {\n          font-family: ", ";\n          font-size: 12px;\n          line-height: 20px;\n          font-weight: 700;\n          color: #fff;\n        }\n      }\n    }\n\n    * + * {\n      margin-left: 10px;\n    }\n  }\n\n  .cart-and-raiting,\n  .retailers-and-user {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 5px 10px;\n    .star-button {\n      button {\n        padding: 3px;\n        color: transparent;\n        -webkit-text-stroke: 1px #808080;\n      }\n    }\n  }\n\n  .retailers-and-user {\n    padding: 0;\n    > * {\n      flex: 1 0 50%;\n      display: flex;\n      padding: 5px;\n      height: 36px;\n    }\n    .retailers-container {\n      border-right: 1px solid #f0f0f0;\n    }\n  }\n\n  &:hover {\n    cursor: pointer;\n    box-shadow: 1px 2px 5px black;\n  }\n"])), _variables.FontFamily.Lato, _variables.FontFamily.AvenirNext);

exports.Container = Container;

var StateReview = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  background: ", ";\n  display: inline-block;\n  padding: 0 10px;\n  border-radius: 5px;\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 20px;\n  color: white;\n"])), function (props) {
  switch (props.backgroundColor) {
    case "rejected_to_provider":
      return "#d90202";

    case "approved":
      return "#28e602";

    case "in_progress":
      return "rgb(24, 160, 251)";

    case "onboarding_flow":
      return "#e6b802";

    default:
      return "gray";
  }
}, _variables.FontFamily.Lato);

exports.StateReview = StateReview;